import { TFunction } from 'i18next';

export const getToolMessage = (toolName?: string, t?: TFunction): string => {
  if (!t) {
    // Fallback to English if t function is not available
    const toolMessages: Record<string, string> = {
      'GetLocationCoordinates': '📍 Figuring out the exact location',
      'get_location_coordinates': '📍 Figuring out the exact location',
      'GetWeatherForecast': '🌤️ Getting the weather forecast',
      'get_weather_forecast': '🌤️ Getting the weather forecast',
      'InterpretWeatherForActivity': '🌦️ Analyzing weather conditions',
      'interpret_weather_for_activity': '🌦️ Analyzing weather conditions',
      'GorskiKotarContentSearch': '🔍 Looking for attractions, trails, events',
      'gorski_kotar_content_search': '🔍 Looking for attractions, trails, events',
      'search_gorski_kotar_content': '🔍 Looking for attractions, trails, events',
      'Unknown': '🤖 AI agent is working',
      'unknown': '🤖 AI agent is working',
    };
    return toolMessages[toolName || 'Unknown'] || `🔧 Using ${toolName}`;
  }

  // Map tool names to translation keys
  const toolNameMap: Record<string, string> = {
    'GetLocationCoordinates': 'getLocationCoordinates',
    'get_location_coordinates': 'getLocationCoordinates',
    'GetWeatherForecast': 'getWeatherForecast',
    'get_weather_forecast': 'getWeatherForecast',
    'InterpretWeatherForActivity': 'interpretWeatherForActivity',
    'interpret_weather_for_activity': 'interpretWeatherForActivity',
    'GorskiKotarContentSearch': 'gorskiKotarContentSearch',
    'gorski_kotar_content_search': 'gorskiKotarContentSearch',
    'search_gorski_kotar_content': 'gorskiKotarContentSearch',
    'Unknown': 'unknown',
    'unknown': 'unknown',
  };

  const translationKey = toolNameMap[toolName || 'unknown'] || 'unknown';
  return t(`tools.${translationKey}`, { defaultValue: `🔧 Using ${toolName}` });
};

export const getGeneralStatusMessage = (status: string, t?: TFunction): string => {
  if (!t) {
    return status;
  }
  
  // You can add more sophisticated status message handling here
  return status;
}; 